import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader/root';
import NotificationService from '../../services/notification.services';
import NotificationPortal from './portal';
import Notifications from './notifications.component';

const notificationService = new NotificationService();

const NotificationIcon = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [userId, setUserId] = useState(0);
  const [isNew, setIsNew] = useState(false);
  const [apiTries, setApiTries] = useState(0);
  const iconPath = `${wbConfig.imageCdnUrl}/images/icons/menu/topnavigation/notifications.png`;
  const { t } = props
  const resetNotification = () => {
    notificationService.resetNewNotificationCount()
      .then((response) => {
        setCount(0);
      });
  }

  const setNotificationCount = (isTrigger = false) => {
    notificationService.getNotificationCount()
      .then((response) => {
        const { success, error, data } = response.data;
        // console.log('response.data', response.data);
        const uid = response.data.userId || 0;
        if (success) {
          const { activity } = data || {};
          if (activity) {
            setCount(parseInt(activity));
            const countValue = parseInt(activity) + 2;
            if (isTrigger) {
              setIsNew(true);
            }
          }
          if (userId === 0 || userId == uid) {
            setUserId(uid);
          }
        }
        else if ((typeof error !== 'undefined' &&
        error == 'user not logged in') ||
        (userId != 0 && userId != uid)) {
          window.location.reload();
        }
      });
  }

  const onClickOpen = () => {
    setIsOpen(!isOpen);
    props.actions.NotificationsLoadData();
    resetNotification();
  }

  const closeModal = () => {
    setIsOpen(false);
  }

  const onKeyDownPress = (e) => {
    // console.log('onKeyDownPress', e.key);
    switch (e.key) {
      case 'ArrowDown':
      case 'Enter':
      case ' ':
        $('.ui-tooltip.wb-tooltip').hide();
        e.preventDefault();
        onClickOpen();
        break;
      case 'ArrowUp':
      case 'Escape':
        setIsOpen(false);
        e.preventDefault();
        break;
      default:
        break;
    }
  }

  /*
  useEffect(() => {
    if (!props.notificationsData.length && apiTries !== 3) {
      props.actions.NotificationsLoadData();
      setApiTries(++apiTries);
    }
  }, [props.notificationsData]);
  */

  useEffect(() => {
    if (!window.isVnextPage()) {
      setNotificationCount();
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setNotificationCount(true);
    }, 1800000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.getElementById('notification-content-wrapper')?.focus()
    }
  }, [isOpen])
  
  return (
    <>
      <div 
        onClick={() => onClickOpen()} 
        onKeyDown={(e) => onKeyDownPress(e)}
        role="button"
        tabIndex="0"
        title={t("Notifications")}
        id="notifications-icon-btn"
      >
        <img width="16px" height="19.5px" 
          style={{marginTop: '4.25px', cursor: 'pointer'}}
          src={iconPath}
          alt=""
        />
        { (count > 0 && <div className="notificationUnSeenCount">{ count }</div> )}
      </div>
      { isOpen && 
          <NotificationPortal>
              <Notifications
                userId={userId}
                isNew={isNew}
                notificationsData={props.notificationsData}
                actions={props.actions}
                resetNotification={resetNotification}
                t={props.t}
                closeModal={closeModal}
                isLoading={props?.isLoading ?? false}
              />
          </NotificationPortal>
      }
    </>
  )
}

const enhance = compose(withTranslation(), hot)
export default enhance(NotificationIcon);
